
import Calendar from "./calendar"
import Decimal from "decimal.js";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

export default function CardForm({ id, dataLoad, calendarText, onAction}) {

    const [formOptions, setFormOptions] = useState({});
    
    const {
        register,
        handleSubmit,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
        watch
    } = useForm();

    const watchedValues = watch();

    // when any of the watched values changes, submit
    useEffect(() => {
        clearErrors();
        handleSubmit(onSubmit)();
    }, [watchedValues.currencyValueInBgn, watchedValues.currencyName, formOptions]);

    const onSubmit = async (data) => {
        try {    
            setCalculatedSum(data, onAction);
        } catch (err) {
            alert("Invalid number or exchange rate");
        }
    };

    const handler = async (e) => {
        clearErrors("cannotFetchData");

        const date = e.currentTarget.value;

        if(!date){
            return;
        }
        
        const currencyData = await dataLoad(date);

        if (!currencyData || currencyData.length === 0) {
            return setError("cannotFetchData", {
                type: "manual",
                message: "Unable to load table data! Please choose a different date",
            });
        }

        const formOptions = currencyData.reduce((acc, curr) => {
            acc[curr.text] = curr.value;
            return acc;
        }, {});

        setFormOptions(formOptions);
    }

    function setCalculatedSum(data, onAction){
        const selectedValue = new Decimal(data.currencyValueInBgn);
        const exchangeRate = new Decimal(formOptions[data.currencyName]);
        const result = selectedValue.times(exchangeRate);
        
        setValue("currencyValueInTargetCurr", result);
        onAction(result.toFixed());
        setCalculationSummary(data, result);
    }

    function setCalculationSummary(data, sum){
        const summary = `${data.currencyValueInBgn} * ${formOptions[data.currencyName]} = ${sum.toFixed()}`;

        setValue("calculationSummary", summary);
    }

    return (
        <form>
            <div className="form-wrapper">
                <Calendar id={id}
                    handler={handler}

                    validation={register("calendarDate", {
                        required: `Please enter ${calendarText} date`
                    })}
                    error={errors.calendarDate}
                >
                </Calendar>
                <div>
                    <select
                        {...register("currencyName", {
                            required: "Please select currency",
                        })}
                        id="currencyName"
                    >
                        <option value="">-- Select --</option>
                        {Object.entries(formOptions).map(([key]) => (
                            <option key={key}>
                                {key}
                            </option>
                        ))}
                    </select>
                    {errors.currencyName && (
                        <div className="error-text">{errors.currencyName.message}</div>
                    )}
                </div>
            </div>

            <div>
            {errors.cannotFetchData && (
                    <div className="error-text">{errors.cannotFetchData.message}</div>
                )}
                <input
                    {...register("currencyValueInBgn", {
                        required: "Please enter a value",
                        validate: (value) => parseFloat(value) > 0 || "Value must be greater than 0",
                    })}
                    id="currencyValueBought"
                    type="number"
                />
                {errors.currencyValueInBgn && (
                    <div className="error-text">{errors.currencyValueInBgn.message}</div>
                )}
            </div>

            <div>
                <input
                    {...register("currencyValueInTargetCurr")}
                    id="currencyValueSold"
                    disabled
                />
            </div>
            <div>
            <p id="calculationSummary">
                {watch("calculationSummary")}
            </p>
            </div>
            <div className="tableDiv" id="purchase"></div>
        </form>
    );
}

